import { Action, State, StateContext } from '@ngxs/store';
import {
  ApiGetProductOfferingsMbbAction,
  ApiGetProductOfferingsMbbSuccessAction,
  MBBOfferingResetAction,
  ApiGetAllMbbRoutersAction,
  ApiGetAllMbbRoutersSuccessAction,
  ApiGetAllMbbRoutersErrorAction,
  ApiGetProductOfferingsMbbErrorAction,
} from './offering-mbb.actions';
import { MbbService } from '../../modules/mbb/services/mbb.service';
import { Injectable, inject } from '@angular/core';
import { MbbSubscriptionOffering, MbbRouter } from '../../modules/mbb/models/mbb-offerings-response.model';
import { NotificationService } from '@core/services/notification.service';
import { catchError, tap } from 'rxjs/operators';

export interface OfferingMbbStateModel {
  products: MbbSubscriptionOffering[];
  routers: MbbRouter[];
  isLoadingMbbProducts: boolean;
  isLoadingMbbRouters: boolean;
}

const initialOfferingMbbState = {
  products: [],
  routers: [],
  isLoadingMbbProducts: false,
  isLoadingMbbRouters: false,
};

@State<OfferingMbbStateModel>({
  name: 'offeringsMbb',
  defaults: initialOfferingMbbState,
})
@Injectable()
export class OfferingMbbState {
  private mbbService = inject(MbbService);
  private notificationService = inject(NotificationService);

  @Action(ApiGetProductOfferingsMbbAction)
  public ApiGetSubscriptionsMbb({ dispatch, patchState }: StateContext<OfferingMbbStateModel>) {
    patchState({ isLoadingMbbProducts: true });

    return this.mbbService.getAllMbbProductOfferings().pipe(
      tap((response: MbbSubscriptionOffering[]) => dispatch(new ApiGetProductOfferingsMbbSuccessAction(response))),
      catchError(() => dispatch(new ApiGetProductOfferingsMbbErrorAction()))
    );
  }

  @Action(ApiGetProductOfferingsMbbSuccessAction)
  public ApiGetSubscriptionsMbbSuccess(
    { patchState }: StateContext<OfferingMbbStateModel>,
    { response }: ApiGetProductOfferingsMbbSuccessAction
  ) {
    patchState({
      products: response,
      isLoadingMbbProducts: false,
    });
  }

  @Action(ApiGetProductOfferingsMbbErrorAction)
  public apiGetProductOfferingsMbbError({ patchState }: StateContext<OfferingMbbStateModel>) {
    this.notificationService.error('Feil ved henting av mbb offerings.');
    patchState({ products: [], isLoadingMbbProducts: false });
  }

  @Action(ApiGetAllMbbRoutersAction)
  public apiGetAllMbbRouters({ dispatch, patchState }: StateContext<OfferingMbbStateModel>) {
    patchState({ isLoadingMbbRouters: true });

    return this.mbbService.getAllMbbRouters().pipe(
      tap((response: MbbRouter[]) => dispatch(new ApiGetAllMbbRoutersSuccessAction(response))),
      catchError(() => dispatch(new ApiGetAllMbbRoutersErrorAction()))
    );
  }

  @Action(ApiGetAllMbbRoutersSuccessAction)
  public apiGetAllMbbRoutersSuccess(
    ctx: StateContext<OfferingMbbStateModel>,
    { response }: ApiGetAllMbbRoutersSuccessAction
  ) {
    ctx.patchState({ routers: response, isLoadingMbbRouters: false });
  }

  @Action(ApiGetAllMbbRoutersErrorAction)
  public apiGetAllMbbRoutersError({ patchState }: StateContext<OfferingMbbStateModel>) {
    this.notificationService.error('Feil ved henting av mbb rutere.');
    patchState({ routers: [], isLoadingMbbRouters: false });
  }

  @Action(MBBOfferingResetAction)
  public mbbOfferingReset(ctx: StateContext<OfferingMbbStateModel>) {
    ctx.setState(initialOfferingMbbState);
  }
}
